// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QkwS","top":"styles_top__1dQdo"};